module.exports = __webpack_public_path__ + "static/img/tudou.b41a4b95.png";